import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M3.60698 10.6594L8 6.63243L12.393 10.6594C12.6461 10.8913 13.0509 10.8913 13.3039 10.6594C13.5654 10.4197 13.5654 10.0247 13.3039 9.78511L8.45546 5.34067C8.2024 5.10869 7.79761 5.10869 7.54454 5.34067L2.69605 9.78511C2.43465 10.0247 2.43465 10.4197 2.69605 10.6594C2.94912 10.8913 3.35391 10.8913 3.60698 10.6594Z",
            fill: "white"
        })
    }));
};
export default Icon;
